import React from 'react';
import './App.css';
import Router from "./app/router/routes";
import { ToastContainer } from 'react-toastify';


function App() {
  return (
    <>
        <Router />
        <ToastContainer />
    </>
  );
}

export default App;
